import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {getStrategySettledPicksRequest} from 'requests';
import './last-picks.scss';
import {Loader} from 'components/Loader';
import Pick from 'components/Cards/Pick';

class LastPicks extends Component {
  state = {
    picks: [],
  };

  async componentDidMount() {
    const {strategyId} = this.props.match.params;
    this.setState({loading: true});

    try {
      const picks = await getStrategySettledPicksRequest(strategyId);
      this.setState({picks, loading: false});
    } catch (err) {
      console.warn('Handled error in Settled Picks:', err);
    }
  }

  render() {
    const {picks, loading} = this.state;

    if (loading) return <Loader />;
    return (
      <div className="last-picks-page">
        {picks.length ? (
          picks.map(pick => <Pick key={pick.id} pick={pick} />)
        ) : (
          <p className="message no-settled">This strategy doesn&apos;t have settled picks.</p>
        )}
      </div>
    );
  }
}

export default withRouter(LastPicks);
